export const NO_VALUE_LABEL = '-'

/** What older records store where a picker was left unset. */
const UNSET_VALUE = '---'

export const toDisplayValue = (value?: string | null) => (!value || value === UNSET_VALUE ? NO_VALUE_LABEL : value)

export const toYesNo = (value?: boolean) => (value ? 'Yes' : 'No')

export const toListLabel = (values?: string[]) => (values?.length ? values.join(', ') : NO_VALUE_LABEL)

export const getDateLabel = (date: Date | null) =>
    date ? date.toLocaleDateString('en-US', { timeZone: 'UTC' }) : NO_VALUE_LABEL
